var map = {
	"./aws.svg": "e47b",
	"./bootstrap.svg": "9452",
	"./css-3.svg": "7654",
	"./html-5.svg": "06a1",
	"./laravel.svg": "5079",
	"./mysql.svg": "b7d9",
	"./nodejs-icon.svg": "2de4",
	"./react.svg": "4896",
	"./sass.svg": "2118",
	"./shopify.svg": "df60",
	"./squarespace.svg": "a400",
	"./strapi.webp": "17b9",
	"./vue.svg": "77be",
	"./woocommerce.svg": "8625",
	"./wordpress-icon.svg": "939c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cca";